<finxone-web-frontend-otp-verification
  class="h-100"
  [widgetConfig]="widgetConfig"
  [contentStyle]="contentStyle"
  [textContentStyle]="textContentStyle"
  [inputBaseStyle]="inputBaseStyle"
  [inputStyle]="inputStyle"
  [inputInactiveStyle]="inputInactiveStyle"
  [verifyButtonStyle]="verifyButtonStyle"
  [resendButtonStyle]="resendButtonStyle"
  [buttonContent]="buttonContent"
  [resendButtonContent]="resendButtonContent"
  [timerTextStyle]="timerTextStyle"
  [timerTextContent]="timerTextContent"
  [userProfileData]="dataIn.userProfileData"
  [fieldType]="fieldType"
  [buttonGlobalStyles]="buttonGlobalStyles"
></finxone-web-frontend-otp-verification>
